export default __webpack_public_path__ + "static/media/9mobile.39c42814.png";